/*
 * @Description: '关于我们'页面所有请求
 * @Author: 任录
 * @Date: 2019-07-22 15:13:52
 * @LastEditTime: 2019-07-22 17:37:49
 */

import * as http from './base'


const getDetail = (param) => {
	var data = {
		pid : param.pid,
		id : param.id,
		page : param.page,
		sort : "publish_time,desc",
		size : 10
	}
	return http.get('/os/detail', data)
}

const getHonor = () => {
	return http.get('/os/honor')
}

const getHonorDetail = (id) => {
	return http.get('/os/honor/detail?id=' + id )
}

const getBuildings = (page) => {
	return http.get('/os/buildings', page)
}

const getBuildingDetail = (id) => {
	return http.get('/os/building/detail?id=' + id)
}

const getInscription = (page) => {
	return http.get('/os/inscription', page)
}

const getInscriptionDetail = (id) => {
	return http.get('/os/inscription/detail?id=' + id)
}

const getHeroes = (page) => {
	return http.get('/os/heroes', page)
}

const getHeroDetail = (id) => {
	return http.get('/os/hero/detail?id=' + id)
}

const articlesPageList = (data) => {
	return http.get('/os/articles', data)
}

export default {
	getDetail,
	getHonor, getHonorDetail,
	getBuildings, getBuildingDetail,
	getInscription, getInscriptionDetail,
	getHeroes, getHeroDetail,
	articlesPageList
}



// WEBPACK FOOTER //
// ./src/http/detail.js